import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_FEEDBACK_BASE = '/feedback';
const API_PATH_FEEDBACK_GUEST = `${API_PATH_FEEDBACK_BASE}/guest`;
const API_PATH_FEEDBACK_USER = `${API_PATH_FEEDBACK_BASE}/user`;


class FeedbackService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @param feedbackData {object} Feedback form data incl. captcha for guest feedback
     * @return {Promise<Object>}
     */
    async submitGuestFeedback(feedbackData) {

        let feedbackRequest = ApiRequestBuilder.post(API_PATH_FEEDBACK_GUEST)
            .json()
            .body(feedbackData)
            .build();

        return this.apiService.executeOrFail(feedbackRequest, 'Error submitting guest feedback');
    }


    /**
     * @param feedbackData {object} Feedback form data for user feedback
     * @return {Promise<Object>}
     */
    async submitUserFeedback(feedbackData) {

        let feedbackRequest = ApiRequestBuilder.post(API_PATH_FEEDBACK_USER)
            .json()
            .withToken()
            .body(feedbackData)
            .build();

        return this.apiService.executeOrFail(feedbackRequest, 'Error submitting user feedback');
    }
}

export default FeedbackService;
